import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';

import LoginPage from 'components/Login';
import Layout from 'components/Layout';
import MainPage from 'components/Main';
import LicenseGeneratePage from 'components/LicenseGenerate';
import LicenseVerifyPage from 'components/LicenseVerify';
import AdminPage from 'components/Admin';

function ProtectedRoute({ children, adminOnly = false }) {
    const { isAuthenticated, isAdmin, loading } = useAuth();
    if (loading) return null;
    if (!isAuthenticated) return <Navigate to="/login" replace />;
    if (adminOnly && !isAdmin) return <Navigate to="/" replace />;
    return children;
}

function PublicRoute({ children }) {
    const { isAuthenticated, loading } = useAuth();
    if (loading) return null;
    if (isAuthenticated) return <Navigate to="/" replace />;
    return children;
}

export default function AppRoutes() {
    return (
        <Routes>
            <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route path="/" element={<MainPage />} />
                <Route path="/generate" element={<LicenseGeneratePage />} />
                <Route path="/verify" element={<LicenseVerifyPage />} />
                <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}
